<div class="auth-details-report">
  <table class="coverage-table" id="vsp-logo-container">
    <tbody>
      <tr>
        <td>
          <img
            alt="vsp logo"
            id="vsp-logo"
            ngSrc="../../assets/images/vsp_dark.png"
            height="27"
            width="72"
          >
        </td>
      </tr>
    </tbody>
  </table>
  <section id="patient-identification">
    <h3>PATIENT IDENTIFICATION</h3>
    <table class="coverage-table">
      <tbody>
        <tr>
          <td class="coverage-label">Patient Name:</td>
          <td class="coverage-option">{{ vsrResponse?.reifiedPatient?.name?.firstName || '' }} {{ vsrResponse?.reifiedPatient?.name?.lastName || '' }}</td>
          <td class="coverage-label">Auth #</td>
          <td>{{ authNumber }}</td>
        </tr>
        <tr>
          <td class="coverage-label">Relationship:</td>
          <td class="coverage-option">{{ vsrResponse?.reifiedPatient?.relationToSubscriber || '' }}</td>
          <td class="coverage-label">Auth Eff Date:</td>
          <td>{{ vsrResponse?.effectiveDate || '' }}</td>
        </tr>
        <tr>
          <td class="coverage-label">Member Name:</td>
          <td class="coverage-option">{{ vsrResponse?.reifiedPatient?.subscriberName?.firstName || '' }} {{ vsrResponse?.reifiedPatient?.subscriberName?.lastName || '' }}</td>
          <td class="coverage-label">Auth Exp. Date:</td>
          <td>{{ vsrResponse?.expirationDate || '' }}</td>
        </tr>
        <tr>
          <td class="coverage-label">Birth Date:</td>
          <td class="coverage-option">{{ vsrResponse?.reifiedPatient?.dateOfBirth || '' }}</td>
        </tr>
      </tbody>
    </table>
  </section>

  <section id="patient-coverage">
    <h3>PATIENT COVERAGE</h3>
    <table class="coverage-table">
      <tbody>
        <tr>
          <td class="coverage-label">Benefit:</td>
          <td class="coverage-option">{{ vsrResponse?.businessProductPackageName || '' }}</td>
          <td class="coverage-label">Network ID:</td>
          <td>{{ vsrResponse?.networkId || '' }}</td>
        </tr>
      </tbody>
    </table>
    <table class="coverage-table">
      <tbody>
        <tr>
          <td class="coverage-label">Eligibility:</td>
          <td class="coverage-option">
            <div *ngFor="let items of vsrResponse?.reifiedEligibility?.authorizedItems;">
              {{ items.description }}:
            </div>
          </td>
          <td>
            <div *ngFor="let items of vsrResponse?.reifiedEligibility?.authorizedItems;">
              {{ items.availability }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="coverage-table">
      <tbody>
      <tr>
        <td class="coverage-label">Copays:</td>
        <td class="coverage-option">
          <div *ngFor="let copay of vsrResponse?.reifiedCoverage?.copaySummary;">
            {{ copay.description }}:
          </div>
        </td>
        <td>
          <div *ngFor="let copay of vsrResponse?.reifiedCoverage?.copaySummary;">
            {{ copay.amount | currency: 'USD':true }}
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <table class="coverage-table">
      <tbody>
      <tr>
        <td class="coverage-label">Allowances:</td>
        <td class="coverage-option">
          <div *ngFor="let allowance of vsrResponse?.reifiedCoverage?.allowanceSummary;">
            {{ allowance.description }}<span *ngIf="allowance.criteria"> ({{ allowance.criteria }})</span>:
          </div>
        </td>
        <td>
          <div *ngFor="let allowance of vsrResponse?.reifiedCoverage?.allowanceSummary;">
            {{ allowance.amount | currency: 'USD':true }}
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </section>

  <section id="report-notes">
    <p *ngIf="vsrResponse?.specialHandlingCodes?.includes('CONTACT_LENS_REMAINING_ALLOWANCE')">
      <strong>
        This authorization is for contact lens remaining allowance.
      </strong>
    </p>
    <div *ngIf="vsrResponse?.reifiedCoverage?.lensEnhancementSummary?.length > 0">
      <p>
        <strong>
          Note: This section only displays overridden lens enhancement coverages.
        </strong>
      </p>
      <h3>OVERRIDDEN LENS ENHANCEMENTS</h3>
      <table class="coverage-table">
        <tbody>
        <tr>
          <td class="coverage-label">Covered:</td>
          <td class="coverage-option">
            <div *ngFor="let enhancement of vsrResponse?.reifiedCoverage?.lensEnhancementSummary;">
              {{ enhancement.description }}
            </div>
          </td>
          <td>&nbsp;</td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
